import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["AlertDialogContextProvider"] */ "/app/src/ContextProviders/AlertDialogContextProvider/AlertDialogContextProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DataContextProvider"] */ "/app/src/ContextProviders/DataContextProvider/DataContextProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingContextProvider"] */ "/app/src/ContextProviders/LoadingContextProvider/LoadingContextProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationContextProvider"] */ "/app/src/ContextProviders/NotificationContext/NotificationContextProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ContextProviders/ThemeRegistry/ThemeRegistry.tsx");
